"use client";

import Script from "next/script";
import { useEffect, useState } from "react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { Analytics } from "@vercel/analytics/next";
import { hentSamtykke, SAMTYKKE_ENDRET, type Samtykke } from "@/lib/samtykke";

// Samler all besøks-sporing (GA4, Meta Pixel, Vercel) ett sted og laster den KUN på
// toppnivå. Når siden er innebygd i en iframe (embed-widget på en tredjeparts nettside)
// skal vi ikke spore besøk på sider vi ikke eier — derfor gaten.
//
// GA4 og Meta Pixel lastes først når besøkende har samtykket (lib/samtykke.ts), og
// lastes inn med én gang samtykket gis i samme økt. Vercel Analytics og Speed
// Insights bruker ikke informasjonskapsler og går uansett.
export default function TrackingScripts() {
  const [enabled, setEnabled] = useState(false);
  const [samtykke, setSamtykke] = useState<Samtykke | null>(null);

  useEffect(() => {
    if (window.self !== window.top) return;
    setEnabled(true);
    const oppdater = () => setSamtykke(hentSamtykke());
    oppdater();
    window.addEventListener(SAMTYKKE_ENDRET, oppdater);
    return () => window.removeEventListener(SAMTYKKE_ENDRET, oppdater);
  }, []);

  if (!enabled) return null;
  const annonser = samtykke?.marketing ? "granted" : "denied";

  return (
    <>
      <SpeedInsights />
      <Analytics />
      {/* Google Analytics GA4 — kun etter samtykke til analyse */}
      {samtykke?.analytics && (
        <>
          <Script
            src="https://www.googletagmanager.com/gtag/js?id=G-JN235PS4K6"
            strategy="afterInteractive"
          />
          <Script id="ga4-init" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('consent', 'default', {
                analytics_storage: 'granted',
                ad_storage: '${annonser}',
                ad_user_data: '${annonser}',
                ad_personalization: '${annonser}',
              });
              gtag('js', new Date());
              gtag('config', 'G-JN235PS4K6', {
                page_path: window.location.pathname,
              });
            `}
          </Script>
        </>
      )}
      {/* Meta Pixel — kun etter samtykke til markedsføring */}
      {samtykke?.marketing && (
      <Script id="meta-pixel" strategy="lazyOnload">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1585781289781051');
          fbq('track', 'PageView');
        `}
      </Script>
      )}
    </>
  );
}
